import ConfigOn from '../ConfigOn';
import Password from '../Password/password';
import Reload from '../../../components/reload/reload';
import PasswordIniti from '../PasswordIniti/passwordIniti';
import AlertModal from '../../../components/AlertModal/AlertModal';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useWebSocket } from '../../../hooks/webSocketContext';

const InitConfig = () => {

    const serial = useParams().id;
    const socket = useWebSocket();

    const [verify, setVerify] = useState(null);
    const [pageConfigs, setPageConfigs] = useState({
        ip: "",
        type: "",
        wifi: "",
        media: "",
        saida: "",
        block: "",
        idioma: "",
        encode: "",
        hostname: "",
        size_buffer: "",
        porta_local: "",
        porta_remota: "",
        output_buffer: "",
        manter_conectado: "",
        block_lang: "",
        block_temp: "",
        block_chart: "",
        block_selected_chart: "",
        block_clock: "",
        block_output: "",
        block_network: "",
        block_average: "",
        block_percent: "",
        selected_chart: {},
        pais: "",
        network: [],
        charts: [],
    });

    const [type, setType] = useState({ color: "", status: "" });
    const [modalShow, setModalShow] = useState(false);
    const [loading, setLoading] = useState(true);
    const [medidas, setMedidas] = useState([]);
    const [details, setDetails] = useState();
    const [formData, setFormData] = useState({});
    const [connectionStabished, setConnectionStabished] = useState(true)

    const [showModal, setShowModal] = useState(false);
    const [msg, setMsg] = useState({ title: "", message: "" });

    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    const [user,] = useState(() => {
        const storedUser = localStorage.getItem('user');

        if (!storedUser) {
            return null;
        }

        try {
            return JSON.parse(storedUser);
        } catch (error) {
            console.error("Erro ao fazer parse do user:", error);
            return null;
        }
    });

    const [password,] = useState(() => {
        const storedUserEncoded = localStorage.getItem('access_key');

        if (!storedUserEncoded) {
            return null;
        }

        try {
            const storedUser = atob(storedUserEncoded);
            return storedUser ? JSON.parse(storedUser) : null;
        } catch (error) {
            console.error("Erro ao decodificar ou fazer parse do access_key:", error);
            return null;
        }
    });

    const sendJoinWhenReady = async () => {

        if (!user?.email) {
            console.error('Usuário não encontrado.');
            return;
        }

        const checkSocketInterval = setInterval(() => {
            if (socket && socket.readyState === WebSocket.OPEN) {

                socket.send(
                    JSON.stringify({
                        type: 'join',
                        room: serial,
                        content: {
                            name: `${user.email}-SGUx`
                        },
                    })
                );

                /* if (password) {
                    socket.send(
                        JSON.stringify({
                            type: 'message',
                            room: serial,
                            content: {
                                command: 'web_browser',
                                parameters: {
                                    value: 'confirm_pass',
                                    page: "login",
                                    password: password
                                }
                            },
                        })
                    );
                } */

                socket.send(
                    JSON.stringify({
                        type: 'message',
                        room: serial,
                        content: {
                            command: 'web_browser',
                            parameters: {
                                value: "pass",
                                page: "login"
                            }
                        },
                    })
                );

                clearInterval(checkSocketInterval);

                socket.onmessage = (event) => {
                    try {
                        const parseJson = JSON.parse(event.data);

                        if (parseJson?.type === "connected") {
                            setConnectionStabished(true);
                            return;
                        }
                        if (parseJson?.type === "desconnect") {
                            setConnectionStabished(false);
                            return;
                        }
                        if (parseJson?.content?.pass === true) {
                            setVerify(4);
                            setLoading(false)
                            return;
                        }
                        else if (parseJson?.content?.pass === false) {
                            setLoading(false)
                            setVerify(2);
                            return;
                        }
                        else if (parseJson?.content?.pass === "Senha correta") {
                            localStorage.setItem('access_isValid', JSON.stringify(true));
                            setVerify(1);
                            return;
                        }
                        else if (parseJson?.content?.pass === "Senha incorreta") {
                            localStorage.setItem('access_key', JSON.stringify(null));
                            localStorage.setItem('access_isValid', JSON.stringify(false));
                            setVerify(4);
                            setLoading(false);
                            setMsg({ title: "Alerta", message: "Senha Incorreta!" });
                            handleShow();
                            return
                        }
                        else if (parseJson?.content?.pass === "Senha não cadastrada") {
                            localStorage.setItem('access_key', JSON.stringify(null));
                            setVerify(2);
                            setLoading(false)
                            return
                        }
                        else if (parseJson?.content?.page === "set_password" && parseJson?.content?.status === "OK") {
                            setType({ "color": "#198754", "status": "Nova Senha Cadastrada!" })
                            setModalShow(true)
                            setVerify(1)
                            setLoading(false)
                            return
                        }
                        else if (parseJson?.content?.status === "OK") {
                            setType({ "color": "#198754", "status": "Atualizado com sucesso!" })
                            setModalShow(true)
                            setLoading(false)
                            return
                        }
                        else if (parseJson?.content?.status === "NOK") {
                            setType({ "color": "red", "status": "Erro ao atualizar!" })
                            setLoading(false)
                            setModalShow(true)
                            return
                        }
                        else if (parseJson?.content?.page === "configs") {
                            localStorage.setItem('page_configs', JSON.stringify(parseJson.content));
                            setPageConfigs(parseJson.content);
                            setLoading(false);
                            return
                        }
                        else if (parseJson?.content?.page === "data") {
                            let j = {}
                            j.json = JSON.parse(parseJson.content.json);
                            j.txt = parseJson.content.txt;
                            j.json_b64 = btoa(parseJson.content.json)
                            j.txt_b64 = btoa(parseJson.content.txt)
                            setFormData(j)
                            setLoading(false)
                            return
                        }
                        else if ((parseJson?.content?.page === "graphic")) {
                            setMedidas(parseJson.content.medidas)
                            setLoading(false)
                            return
                        }
                        else if (parseJson?.content?.page === "change_password") {
                            setType({ "color": "#198754", "status": "Atualizado com sucesso!" })
                            setLoading(false)
                            return
                        }
                        else if (parseJson?.content?.page === "details") {
                            setDetails(parseJson.content)
                            setLoading(false)
                            return
                        }
                        else {
                            //console.log("parseJson:", parseJson);
                            return
                        }

                    } catch (error) {
                        console.error('Erro ao processar a mensagem:', error);
                    }
                };
            }
        }, 200);
    };

    const handleConfirmPass = (password) => {
        localStorage.setItem('access_key', btoa(JSON.stringify(password)));
        socket.send(
            JSON.stringify({
                type: 'message',
                room: serial,
                content: {
                    command: 'web_browser',
                    parameters: {
                        value: 'confirm_pass',
                        page: 'login',
                        password: password
                    }
                },
            })
        );
    };

    useEffect(() => {
        if (socket && user) {
            sendJoinWhenReady();
        }
    }, [socket, user, password]);

    return (
        <div style={{ background: "silver" }}>
            {
                <AlertModal
                    show={showModal}
                    handleClose={handleClose}
                    msg={msg}
                />
            }
            {verify === null ? (
                <Reload />
            ) : verify === 1 ? (
                <ConfigOn
                    serial={serial}
                    socket={socket}
                    type={type}
                    loading={loading}
                    setLoading={setLoading}
                    modalShow={modalShow}
                    setModalShow={setModalShow}
                    pageConfigs={pageConfigs}
                    formData={formData}
                    medidas={medidas}
                    details={details}
                    user={user}
                    connectionStabished={connectionStabished}
                />
            ) : verify === 2 ? (
                <Password
                    serial={serial}
                    socket={socket}
                    loading={loading}
                    setLoading={setLoading}
                />
            ) : verify === 4 ? (
                <PasswordIniti
                    loading={loading}
                    setLoading={setLoading}
                    handleConfirmPass={handleConfirmPass}
                />
            ) : null
            }
        </div>
    );
}

export default InitConfig;
